import { useEffect } from 'react';

/**
 * Meta Pixel — Gestalt Session Ready (DPS45).
 * Único pixel y único lugar donde se inicializa.
 * - Carga el código base de Meta solo si todavía no existe.
 * - Hace `init` de este ID una sola vez.
 * - Dispara PageView una sola vez por carga de página, con `trackSingle`
 *   (solo a este pixel, aunque haya otros en la página) y un eventID único
 *   para que Meta deduplique si llegara a repetirse.
 */
const PIXEL_ID = '4484896461784944';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};
type PixelWindow = Window & {
  fbq?: Fbq;
  _fbq?: Fbq;
  __metaPixelInit?: Record<string, boolean>;
  __metaPixelPageViewSent?: Record<string, boolean>;
};
function loadBaseCode(w: PixelWindow) {
  if (w.fbq) return;
  const n = function (...args: unknown[]) {
    if (n.callMethod) n.callMethod(...args);else n.queue.push(args);
  } as Fbq;
  n.queue = [];
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  w.fbq = n;
  if (!w._fbq) w._fbq = n;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as PixelWindow;
    w.__metaPixelInit = w.__metaPixelInit ?? {};
    w.__metaPixelPageViewSent = w.__metaPixelPageViewSent ?? {};
    loadBaseCode(w);
    const fbq = w.fbq;
    if (!fbq) return;
    if (!w.__metaPixelInit[PIXEL_ID]) {
      w.__metaPixelInit[PIXEL_ID] = true;
      fbq('init', PIXEL_ID);
    }
    if (!w.__metaPixelPageViewSent[PIXEL_ID]) {
      w.__metaPixelPageViewSent[PIXEL_ID] = true;
      const eventID = `pv-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      fbq('trackSingle', PIXEL_ID, 'PageView', {}, {
        eventID
      });
    }
  }, []);
  return null;
}